"use client";
import { css as t } from "@emotion/react";
import { COLORS as o } from "../../tokens/colors/Colors.js";
import { FONT_SIZES as n } from "../../tokens/font-sizes/FontSizes.js";
import { LINE_HEIGHTS as s } from "../../tokens/line-heights/LineHeights.js";
const l = t`
	/* Regular */
	@font-face {
		font-family: SKFSans;
		src: url('https://fonts.skf.com/SKFSans-Regular.woff');
	}

	/* Regular & Italic */
	@font-face {
		font-family: SKFSans;
		font-style: italic;
		src: url('https://fonts.skf.com/SKFSans-Italic.woff');
	}

	/* Light */
	@font-face {
		font-family: SKFSans;
		font-weight: 100;
		src: url('https://fonts.skf.com/SKFSans-Light.woff');
	}

	/* Light | Italic */
	@font-face {
		font-family: SKFSans;
		font-style: italic;
		font-weight: 100;
		src: url('https://fonts.skf.com/SKFSans-LightItalic.woff');
	}

	/* Medium */
	@font-face {
		font-family: SKFSans;
		font-weight: 500;
		src: url('https://fonts.skf.com/SKFSans-Medium.woff');
	}

	/* Medium | Italic */
	@font-face {
		font-family: SKFSans;
		font-style: italic;
		font-weight: 500;
		src: url('https://fonts.skf.com/SKFSans-MediumItalic.woff');
	}

	/* Bold */
	@font-face {
		font-family: SKFSans;
		font-weight: 700;
		src: url('https://fonts.skf.com/SKFSans-Bold.woff');
	}

	/* Bold | Italic */
	@font-face {
		font-family: SKFSans;
		font-style: italic;
		font-weight: 700;
		src: url('https://fonts.skf.com/SKFSans-BoldItalic.woff');
	}

	*,
	*::before,
	*::after {
		box-sizing: border-box;
	}

	/* Remove default margin */
	body,
	h1,
	h2,
	h3,
	h4 {
		margin: 0;
	}

	/* Set core body defaults */
	body,
	:host {
		color: ${o.black};
		font:
			${n.md} / ${s.md} SKFSans,
			Arial,
			sans-serif;
		text-rendering: optimizeSpeed;

		&:has(.fe-modal) {
			overflow: hidden;
		}
	}

	/* Inherit fonts for inputs and buttons */
	input,
	button,
	textarea,
	select {
		font: inherit;
	}

	/* Set core button defaults */
	button {
		background: none;
		border: 0;
		cursor: pointer;
		margin: 0;
		padding: 0;

		&:disabled {
			cursor: not-allowed;
		}
	}

	img {
		display: block;
		max-width: 100%;
	}

	ol,
	ul {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.skf-sans {
		font-family: SKFSans, Arial, sans-serif;
	}

	.skf-sans-italic {
		font-family: SKFSans, Arial, sans-serif;
		font-style: italic;
	}

	.skf-sans-light {
		font-family: SKFSans, Arial, sans-serif;
		font-weight: 100;
	}

	.skf-sans-light-italic {
		font-family: SKFSans, Arial, sans-serif;
		font-style: italic;
		font-weight: 100;
	}

	.skf-sans-medium {
		font-family: SKFSans, Arial, sans-serif;
		font-weight: 500;
	}

	.skf-sans-medium-italic {
		font-family: SKFSans, Arial, sans-serif;
		font-style: italic;
		font-weight: 500;
	}

	.skf-sans-bold {
		font-family: SKFSans, Arial, sans-serif;
		font-weight: 700;
	}

	.skf-sans-bold-italic {
		font-family: SKFSans, Arial, sans-serif;
		font-style: italic;
		font-weight: 700;
	}

	/* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
	@media (prefers-reduced-motion: reduce) {
		html:focus-within {
			scroll-behavior: auto;
		}

		*,
		*::before,
		*::after {
			animation-delay: 0.01ms !important;
			animation-duration: 0.01ms !important;
			animation-iteration-count: 1 !important;
			scroll-behavior: auto !important;
			transition-duration: 0.01ms !important;
		}
	}
`;
export {
  l as globalStyles
};
